import { useEffect, useRef } from 'react';
import { useMatch } from 'react-router-dom';
import { isProduction } from 'Douleutaras/constants/system';
import { getAbsoluteUrl } from 'Douleutaras/utilities/url-builder';
import { useSalesForceChat } from 'Douleutaras/providers/chat/hooks/useSalesForceChat';
import { useSupportLauncherActive } from 'Douleutaras/functional-components/support-widget/useFloatingSupportWidget';

import './chat/SalesForceChat.provider.scss';

export const WebChatProvider = () => {
  const salesForceChat = useSalesForceChat();

  const clientDashboardRoute = useMatch({
    path: getAbsoluteUrl('CLIENT_DASHBOARD.INDEX'),
    end: true
  });
  const isClientDashboard = clientDashboardRoute !== null;
  const isSupportLauncher = useSupportLauncherActive();
  // Where the support widget renders it is the chat's launcher (#5620); decide once its answer lands.
  const showChatButton = isClientDashboard && isSupportLauncher === false;
  // Read after the async load, which can settle after the decision has changed.
  const showChatButtonRef = useRef(showChatButton);

  showChatButtonRef.current = showChatButton;

  if (!isProduction) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  const checkChatStatus = () => showChatButtonRef.current
    ? salesForceChat.show()
    : salesForceChat.hide();

  useEffect(() => {
    if (salesForceChat && isClientDashboard) {
      // Hidden on load, so a page where the widget is the launcher never flashes Salesforce's own.
      salesForceChat
        .load({ displayHelpButton: false })
        .then(() => checkChatStatus());

      return () => salesForceChat.unmount();
    }
  }, [salesForceChat]);

  useEffect(() => {
    if (!salesForceChat) {
      return;
    }
    checkChatStatus();
  }, [showChatButton]);

  // tslint:disable-next-line:no-null-keyword
  return null;
};
